import { render } from "./ProductsGallery.vue?vue&type=template&id=3f4c1c9a"
import script from "./ProductsGallery.vue?vue&type=script&lang=js"
export * from "./ProductsGallery.vue?vue&type=script&lang=js"

import "./ProductsGallery.vue?vue&type=style&index=0&id=3f4c1c9a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__